export default __webpack_public_path__ + "static/media/course_correction_service.a9bc8aeb.png";